import { Box } from '@mui/material';
import React from 'react';

import { LockIcon } from '../../icons';

type Props = {
  children: React.ReactNode;
};

const SecureText: React.FC<Props> = ({ children }: Props) => (
  <>
    <Box component="span" mr={1}>
      <LockIcon fontSize="inherit" />
    </Box>
    {children}
  </>
);

export { SecureText };
